<template>
  <div class="accessorial-inline-edit">
    <Chip
      class="accessorial-chip"
      :removable="editable"
      @remove="emit('remove', internalValue)"
    >
      <PopupDropdown
        v-model="internalValue"
        :options="accessorialCodes"
        option-label="name"
        :disabled="!editable"
      >
        <template #placeholder>
          <span>
            {{ internalValue?.name }}
          </span>
          <span
            v-if="stopSequenceNumber"
            class="accessorial-stop-sequence-number"
          >
            {{ t('shipments.stops') }} {{ stopSequenceNumber }}
          </span>
        </template>
      </PopupDropdown>
    </Chip>
  </div>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';
import { AccessorialCode } from '@rygen/rygen-ui/model';

import PopupDropdown from '@rygen/rygen-ui/components/popup/PopupDropdown.vue';
import Chip from 'primevue/chip';

const props = defineProps({
  modelValue: {
    type: AccessorialCode,
    default: () => new AccessorialCode(),
  },
  stopSequenceNumber: {
    type: Number,
    required: false,
    default: () => undefined,
  },
  accessorialCodes: {
    type: Array as PropType<AccessorialCode[]>,
    default: () => [],
  },
  editable: {
    type: Boolean,
    default: () => true,
  },
});
const { modelValue, accessorialCodes, editable, stopSequenceNumber } =
  toRefs(props);
const emit = defineEmits<{
  (event: 'remove', code: AccessorialCode): void;
  (event: 'update:model-value', newVal: AccessorialCode): void;
}>();

const { t } = useI18n();

const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts) => new AccessorialCode(opts),
});
</script>

<style>
.accessorial-inline-edit {
  .accessorial-chip {
    background: var(--info-light-color);
    color: var(--info-color);
    min-height: 2em;

    .accessorial-stop-sequence-number {
      font-size: x-small;
    }

    .popup-dropdown {
      & > .popup-inputgroup-card {
        top: calc(var(--sp-8) * -1);
        left: calc(var(--sp-7) * -1);
        width: max-content;
      }

      .popup-inputgroup-edit-icon {
        right: calc(var(--sp-4) * -1);
        top: calc(var(--sp-4) * -1);
      }
    }
  }
}
</style>
